import React from 'react'
import { OnBoarding } from './OnBoarding'

export const Features = () => (
  <OnBoarding />
)



// WEBPACK FOOTER //
// ./sampleProject/src/Features/index.tsx